'use client'

import { Sparkles } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTranslation } from '@/lib/i18n'
import { cn } from '@/lib/utils'
import { useKnowledgeAskStore } from './ask-store'

/**
 * The "Ask AI" button in a portal header: the main application's header button
 * (`components/ai-chat/header-ask-ai-button.tsx`: an outline shadcn Button with
 * the Sparkles icon and the label), opening the portal's policy assistant.
 *
 * It reads whether an assistant is available from the shared store, which the
 * launcher in the portal layout fills from GET /assistant, so it never fetches
 * anything of its own. On a phone the label folds away and the icon stays
 * (the header is narrow there); the name is the same either way.
 */
export function KnowledgeAskAiButton({ className }: { className?: string }) {
  const { t } = useTranslation()
  const available = useKnowledgeAskStore((s) => s.available)
  const openAssistant = useKnowledgeAskStore((s) => s.openAssistant)
  if (!available) return null
  const label = t('knowledgePortal.launcher.askAi')
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      aria-label={label}
      aria-haspopup="dialog"
      data-testid="portal-ask-ai-button"
      onClick={(event) => openAssistant({ opener: event.currentTarget })}
      className={cn('gap-2 text-foreground shadow-sm', className)}
    >
      <Sparkles className="size-4" aria-hidden="true" />
      <span className="hidden sm:inline">{label}</span>
    </Button>
  )
}
